import Criteria from './criteria'
export default Criteria

export const query = graphql`
  query criteria202526Query {
    gemeinden: allGemeinden202526Json {
      edges {
        node {
          name
          iso
          VIF_Kategorie
          Anz_Krippe
          Anz_KiGa
          Anz_alterserw_KiGa
          Anz_Hort
          schulischeNMB_VS_Ki
          oeffTag_0_3J
          oeffTag_3_6J
          oeffWoche_0_3J
          oeffWoche_3_6J
          geschlJahr_0_3J
          geschlJahr_3_6J
          Mittagessen_0_3
          Mittagessen_3_6
          VIF_0_3
          VIF_3_6
          VS_Ki_NMB
        }
      }
    }
    betriebe: allBetriebe202526Json {
      edges {
        node {
          GEMNR
          Bezeichnung
          Adresse
          PLZ
          Ort
          Movon1
          Mobis1
          Divon1
          Dibis1
          Mivon1
          Mibis1
          Dovon1
          Dobis1
          Frvon1
          Frbis1
          Movon2
          Mobis2
          Divon2
          Dibis2
          Mivon2
          Mibis2
          Dovon2
          Dobis2
          Frvon2
          Frbis2
          Sommer
          Weihnacht
          Semester
          Ostern
          sonstzu
          Essen
        }
      }
    }
    zusatzGemeinden: allGemeindenZusatzinfosJson {
      edges {
        node {
          Code_2015
          Website_Gemeinde
          Telefon_Gemeinde
          Zusatzinfo
        }
      }
    }
    zusatzBetriebe: allBetriebeZusatzinfosJson {
      edges {
        node {
          GEMNR
          Telefon_Einrichtung
        }
      }
    }
    kooperationen: allKooperationen2025Json {
      edges {
        node {
          iso
          koop_u3J_GEM
          koop_3_6J_GEM
          koop_NMB_GEM
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/criteria202526.js